function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { createElement } from "react";
import { useId } from "@react-aria/utils";
export var ICON_SIZES = {
    xs: "16px",
    sm: "20px",
    md: "24px",
    lg: "32px"
};
var defaultAttributes = {
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg"
};
export var useSvgAttributes = function(_param) {
    var ariaLabelledBy = _param["aria-labelledby"], title = _param.title, description = _param.description, rest = _object_without_properties(_param, [
        "aria-labelledby",
        "title",
        "description"
    ]);
    var attributes = _object_spread({}, defaultAttributes, rest);
    var ariaId = useId();
    var _attributes_id;
    attributes.id = (_attributes_id = attributes.id) !== null && _attributes_id !== void 0 ? _attributes_id : ariaId;
    var labelledBy = [];
    if (ariaLabelledBy) {
        labelledBy.push(ariaLabelledBy);
    }
    var titleElement;
    if (title) {
        var titleId = "".concat(attributes.id, "-title");
        titleElement = createElement("title", {
            id: titleId
        }, title);
        labelledBy.push(titleId);
    }
    var descElement;
    if (title && description) {
        var descId = "".concat(attributes.id, "-desc");
        descElement = createElement("desc", {
            id: descId
        }, description);
        labelledBy.push(descId);
    }
    if (labelledBy.length > 0) {
        attributes["aria-labelledby"] = labelledBy.join(" ");
    }
    if (!(attributes["aria-label"] || ariaLabelledBy || title)) {
        attributes["aria-hidden"] = "true";
        attributes.tabIndex = undefined;
    }
    var _attributes_role;
    attributes.role = (_attributes_role = attributes.role) !== null && _attributes_role !== void 0 ? _attributes_role : "img";
    return {
        attributes: attributes,
        title: titleElement,
        desc: descElement
    };
};
export var useIconAttributes = function(_param) {
    var _param_size = _param.size, size = _param_size === void 0 ? "md" : _param_size, title = _param.title, description = _param.description, attributes = _object_without_properties(_param, [
        "size",
        "title",
        "description"
    ]);
    attributes.width = ICON_SIZES[size];
    attributes.height = ICON_SIZES[size];
    return useSvgAttributes(_object_spread_props(_object_spread({}, attributes), {
        title: title,
        description: description
    }));
};
export var useIllustrationAttributes = function(props) {
    return useSvgAttributes(props);
};
export default useSvgAttributes;
